import {
	Breakpoints,
	Checkbox,
	Layout,
	Richtext,
	Text,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import {
	InputError,
	LastNavigation,
	LssiTkmQuestions,
	PoliticaPrivacidad,
} from 'src/components';

export const TheOriginalsConfirmacion = () => {
	const { register, errors } = useFormContext();
	const termsUrl =
		'https://www.volkswagen-comerciales.es/app/theoriginalsfest/pdf/terminos_condiciones.pdf';

	return (
		<Layout
			allowOverflowingContent
			appearance={{
				[Breakpoints.default]: [
					{ name: '.', columns: 2 },
					{ name: 'a', columns: 20 },
					{ name: '.', columns: 2 },
				],
				[Breakpoints.b960]: [
					{ name: '.', columns: 3 },
					{ name: 'a', columns: 18 },
					{ name: '.', columns: 3 },
				],
				[Breakpoints.b1280]: [
					{ name: '.', columns: 5 },
					{ name: 'a', columns: 14 },
					{ name: '.', columns: 5 },
				],
				[Breakpoints.b1920]: [
					{ name: '.', columns: 6 },
					{ name: 'a', columns: 12 },
					{ name: '.', columns: 6 },
				],
				[Breakpoints.b2560]: [
					{ name: '.', columns: 7 },
					{ name: 'a', columns: 10 },
					{ name: '.', columns: 7 },
				],
			}}
		>
			<Text appearance={TokenTextAppearance.headline300}>
				¿Seguimos <Text bold> en contacto?</Text>
			</Text>
			<LssiTkmQuestions
				isComerciales={true}
				showTitle={false}
				formTheme="main"
			/>

			<div style={{ paddingBottom: '32px' }}>
				<Checkbox
					label={
						<Richtext
							markdown={`Mediante el envío de este formulario, aceptas los <a target="_blank" href="${termsUrl}">Términos y condiciones</a>*`}
							dangerouslyParseRawHTML
						/>
					}
					value="true"
					name="terms"
					ref={ref => {
						register(ref, { required: true });
					}}
				/>
				{errors['terms'] ? (
					<InputError className="error-field">
						Este campo es obligatorio
					</InputError>
				) : null}
			</div>

			<PoliticaPrivacidad />

			<Text color={TokenTextColor.secondary}>*Campos obligatorios</Text>

			<LastNavigation
				KoTitle="Uy, algo ha pasado"
				KoBody="Por alguna razón no hemos podido guardar tu respuesta. ¿Lo intentamos de nuevo?"
				loadingCopy="Enviando tu petición"
			/>
		</Layout>
	);
};
